export default __webpack_public_path__ + "static/media/mores.2eebba94.svg";